var map = {
	"./ar.json": "af08",
	"./cn.json": "f4a5",
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./hi.json": "7a03",
	"./id.json": "210c",
	"./jp.json": "9e97",
	"./ko.json": "dd11",
	"./my.json": "3ecc",
	"./ph.json": "d486",
	"./pt.json": "5d67",
	"./rs.json": "58ad",
	"./th.json": "8680",
	"./vn.json": "8c1f",
	"./zh.json": "3504"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";